<template functional>
  <div>
    <!--
        <el-popconfirm
        confirm-button-text="Si"
        cancel-button-text="No"
        icon="el-icon-info"
        icon-color="red"
        title="¿Seguro que quiere eliminar este registro?"
        @confirm="deletePayment(scope.$index, scope.row)"
        >
        <el-button slot="reference" type="danger" size="mini">
            <i class="el-icon-delete"></i>
        </el-button>
        </el-popconfirm>
        -->
    <el-button
      slot="reference"
      type="primary"
      size="mini"
      style="margin-left: 3px"
      @click="$options.changeProjectLineDate(props, data)"
    >
      <i class="el-icon-edit"></i>
    </el-button>
  </div>
</template>

<script>
export default {
  name: "ColumnPaymentChange",
  changeProjectLineDate(props, data) {
    data;
    //console.log("props: ", props, "\n data: ", data)
    //console.log("changingDate")
    props.changeProjectLineDate(props.row);
  }
};
</script>

<style></style>
